import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Box } from '@material-ui/core';
import Table from '../../../containers/common/tables/tableContainer';
import { synchronizationLogTable } from '../../../settings/constants/endpoints/tableEndpoints';
import globals from '../../../globals/communityGlobals';
import KeyboardDateSelector from '../../common/KeyboardDateTimeSelectors/KeyboardDateSelector';
import { isValidDate } from '../../../utils/dates';

const locale = globals.getArea('admin');

const columns = [
  {
    Header: locale.getMsg('eventType'),
    accessor: 'eventType',
  },
  {
    Header: locale.getMsg('eventData'),
    accessor: 'eventData',
  },
  {
    Header: locale.getMsg('createdDate'),
    id: 'createdDate',
    accessor: row => moment(row.createdDate).format(globals.dateFormats.shortWithLongTime),
  },
];

class SyncLog extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: this.truncateDate(),
      callbackModel: {
        funcName: '',
        funcParams: null,
      },
    };
  }

  handleDateChange = date => {
    const selectedDate = date ? this.truncateDate(date) : '';

    this.setState({
      selectedDate,
      callbackModel: isValidDate(selectedDate)
        ? {
            funcName: 'updateParamsAndGetData',
            funcParams: {
              from: selectedDate ? selectedDate.format(globals.dateFormats.localApiFormat) : '',
            },
          }
        : {
            funcName: '',
            funcParams: {},
          },
    });
  };
  truncateDate = date => {
    const momentDate = date ? moment(date) : globals.now;
    return momentDate.startOf('day').utcOffset(0, true);
  };
  render() {
    const { selectedDate, callbackModel } = this.state;

    const shouldFetchData = selectedDate && isValidDate(selectedDate);

    return (
      <div>
        <Box display="flex" p={1}>
          <KeyboardDateSelector
            label={locale.getMsg('synchronizationLogFromDate')}
            value={selectedDate ? new Date(selectedDate) : null}
            onChange={date => this.handleDateChange(date)}
          />
        </Box>

        <Table
          reloadCallback={shouldFetchData ? callbackModel : { funcName: '', funcParams: null }}
          afterReloadCallback={() => this.setState({ callbackModel: { funcName: '', funcParams: null } })}
          reduxIdentifier="synchronizationLogs"
          endpoint={synchronizationLogTable}
          columns={columns}
          style={{ padding: '8px' }}
          initialSearchParams={{
            from: shouldFetchData ? selectedDate.format(globals.dateFormats.localApiFormat) : '',
            pageNumber: 1,
            pageSize: 30,
          }}
          noDataText={locale.getMsg('synchronizationLogNoData')}
        />
      </div>
    );
  }
}

SyncLog.propTypes = {
  setTableRef: PropTypes.func.isRequired,
};

export default SyncLog;
